import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=0e064fcc&"
import script from "./AddPartner.vue?vue&type=script&lang=js&"
export * from "./AddPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports